import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

// filters: [{ label: "Active", onClick: () => {} }, { label: "Archived", onClick: () => {} }]
function Search({ search, handleSearch, filters, inputId, className = "input-group mb-3" }) {
  const { t } = useTranslation();

  return (
    <div className={className}>
      {filters && filters.length > 0 && (
        <>
          <button
            className="btn btn-white dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {t("menu.filter")} <b className="caret"></b>
          </button>
          <div className="dropdown-menu">
            {filters.map((filter, index) => (
              <a
                key={index}
                className="dropdown-item"
                href="#/"
                onClick={filter.onClick}
              >
                {filter.label}
              </a>
            ))}
          </div>
        </>
      )}
      <div className="flex-fill">
        <div className="input-group">
          <div className="input-group-text bg-light">
            <i className="fa fa-search opacity-5"></i>
          </div>
          <input
            id={inputId}
            type="text"
            className="form-control"
            placeholder={t("menu.search") + "..."}
            onChange={handleSearch}
            value={search}
          />
          {search && (
            <button
              type="button"
              className="btn btn-default bg-light"
              onClick={() => handleSearch({ target: { value: "" } })}
            >
              <i className="fa fa-times opacity-5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

Search.propTypes = {
  search: PropTypes.string.isRequired,
  handleSearch: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    }),
  ),
  inputId: PropTypes.string,
  className: PropTypes.string,
};

export default Search;
